import { Deserializable } from '../protocols/deserializable';
import { Address } from '../users/dto/address';
import { TransferInDepositAccountTypeId } from '../enum/shared/transfer-in-deposit-account-type-id';
import { GoverningJurisdictionTypeId } from '../enum/shared/governing-jurisdiction-type-id';
import { TransferInSourceAccountTypeId } from '../enum/shared/transfer-in-source-account-type-id.enum';
import { TransferInLockTypeId } from '../enum/shared/transfer-in-lock-type-id.enum';

export class TransferInSubmission implements Deserializable {
  public new!: TransferInSubmissionData;
  public transferRecord!: TransferInTransferRecord | null;

  public hasIncompleteTransferRecord(): boolean {
    const record = this.transferRecord;
    return [
      record?.institutionName,
      record?.accountNumber,
      record?.expectedAmount,
      record?.lockTypeId,
      record?.pensionLegislationId
    ].some(value => value === null || value === undefined || value === '');
  }

  public onDeserialize(): void {
    if (this.new) {
      this.new = window.injector.Deserialize.instanceOf(TransferInSubmissionData, this.new);
    }
  }
}

export class TransferInSubmissionData implements Deserializable {
  public sourceAccountTypeId!: TransferInSourceAccountTypeId;
  public accountNumber!: string;
  public institutionName!: string;
  public jurisdictionId!: GoverningJurisdictionTypeId | null;
  public institutionAddress!: Address | null;
  public financialAdvisor!: TransferInFinancialAdvisor | null;
  public estimatedAmount!: number;
  public isEntireBalance!: boolean;
  public depositAccountTypeId!: TransferInDepositAccountTypeId;

  public onDeserialize(): void {
    if (this.institutionAddress) {
      this.institutionAddress = window.injector.Deserialize.instanceOf(Address, this.institutionAddress);
    }
  }
}

export interface TransferInFinancialAdvisor {
  advisorName: string;
  advisorCompany: string;
  email: string;
  phoneNumberCountryCode: string;
  phoneNumber: string;
}

export interface TransferInTransferRecord {
  institutionName: string | null;
  accountNumber: string | null;
  expectedAmount: number | null;
  lockTypeId: TransferInLockTypeId | null;
  pensionLegislationId: GoverningJurisdictionTypeId | null;
  isRetiringAllowance: boolean;
  isAffiliatedFinancialInstitution: boolean;
}
